import { cloneDeep } from 'lodash-es';
import i18n from '@/lang';
import { saveAs } from 'file-saver';
import ExcelJs from 'exceljs';
import { ROW_TMP } from './consts';

// 规则校验
export const validatePrice = (arr) => {
  // 校验输入参数是否为数组
  if (!Array.isArray(arr)) {
    return false;
  }

  // 空数组直接返回true
  if (arr.length === 0) {
    return true;
  }

  // 校验每个元素是否符合规则
  return arr.every((item) => {
    const { feeTypeCode, deliveryFeeRatio, startNumber, endNumber, specialRules } = item;

    // 校验费用类型
    if (!feeTypeCode) {
      return false;
    }

    if (specialRules === 2) {
      return !(!startNumber || !endNumber);
    }

    // 校验计费规则：必须是有效的正小数
    return !(!deliveryFeeRatio || deliveryFeeRatio <= 0);
  });
};

// 下载模板
export const { SEPARATOR, downloadTemplate, importTemplate, downloadQuotation } = (() => {
  const SEPARATOR = '->'; // 分隔符

  // 模板标题
  const headArr = [
    {
      header: i18n.t('basicData.PartitionName') + '/' + i18n.t('basicData.routeName'), // 分区/车线
      key: 'partitionAffiliateId',
      width: 30
    },
    {
      header: i18n.t('basicData.ExpenseType') + '*', // 费用类型
      key: 'feeTypeCode',
      width: 30
    },
    {
      header: i18n.t('basicData.startValueInclusive') + '*', // 开始值（包含）
      key: 'startNumber',
      width: 30
    },
    {
      header: i18n.t('basicData.endValueExclusive') + '*', // 结束值（不包含）
      key: 'endNumber',
      width: 30
    },
    {
      header: i18n.t('basicData.BillingRules') + '*', // 计费规则
      key: 'deliveryFeeRatio',
      width: 30
    },
    {
      header: 'ID', // id 下载报价的时候存在
      key: 'id',
      width: 20
    }
  ];
  // 分区
  const PartitionArr = [
    {
      header: i18n.t('basicData.PartitionName') + '/' + i18n.t('basicData.routeName'), // 车线
      key: 'partitionAffiliateId',
      width: 20
    }

  ];

  /**
   * 获取头部，选择与未选择分区，对于索引为0的标题有区别
   *   如果选择了分区则 索引为0 需要加上 *
   *   @param {any[]} list 分区名称/车线名称
   *   @returns {any[]}
   */
  const getHeadObj = (list) => {
    const arr = cloneDeep(headArr);
    if (list.length > 0) {
      arr[0].header = arr[0].header + '*';
      return arr;
    }
    return arr;
  };

  /**
   * 获取 sheet2 sheet3 数据
   * @param {any[]} arr2 分区
   * @param {any[]} arr3 费用类型
   * @param businessType 业务类型
   * @returns {object}

   */
  const getSheet2AndSheet3Data = (arr2, arr3, businessType) => {
    const row = {
      // 分区
      sheet2: {
        columns: [
          ...PartitionArr
        ],
        arr: []
      },

      // 费用类型
      sheet3: {
        columns: [
          headArr[1]
        ],
        arr: []
      }
    };

    console.log(arr2, arr3);

    // @ts-ignore 分区 填充下拉数据
    row.sheet2.arr = arr2.map((item) => {
      if (businessType === 5) {
        const { id, name } = item;
        return {
          [row.sheet2.columns[0].key]: `${name}${SEPARATOR}${id}`
        };
      }
      const { id, partitionIdentifier } = item;
      return {
        [row.sheet2.columns[0].key]: `${partitionIdentifier}${SEPARATOR}${id}`
      };
    });

    // 费用类型 填充下拉数据
    row.sheet3.arr = arr3.map(item => {
      return {
        [row.sheet3.columns[0].key]: `${item.displayName}${SEPARATOR}${item.code}`
      };
    });

    return row;
  };

  /**
   * 生成空白模板
   * @param {any[]} list 所有分区/车线
   * @param feeList 费用类型
   * @param businessType 业务类型
   * @param quotationType 报价类型
   * @param {any[]} sheet1RowArr 下载报价的时候才需要传
   */
  const createTemplate = (list, feeList, businessType, quotationType, sheet1RowArr = []) => {
    const wb = new ExcelJs.Workbook();
    const Sheet1 = wb.addWorksheet(i18n.t('basicData.otherRules'));
    const Sheet2 = wb.addWorksheet('Sheet2');
    const Sheet3 = wb.addWorksheet('Sheet3');

    // 分区处理
    const columns = getHeadObj(list);
    // 通用模板，删除第一行
    if (!quotationType) {
      columns.shift();
    }
    // 下载报价的时候
    if (!sheet1RowArr.length) {
      columns.pop();
    }
    console.log(columns);
    Sheet1.columns = columns;
    Sheet1.getRow(1).font = {
      color: { argb: '000000' },
      bold: true
    };

    // 数据回填
    if (sheet1RowArr.length) {
      Sheet1.addRows(sheet1RowArr);
    }

    let subregionArr = []; // 分区/车线
    // 分区存在
    if (list && list.length > 0) {
      subregionArr = list;
    }

    const { sheet2, sheet3 } = getSheet2AndSheet3Data(subregionArr, feeList, businessType);

    // 分区/车线
    Sheet2.columns = sheet2.columns;
    Sheet2.addRows(sheet2.arr);
    if (!quotationType) {
      Sheet2.addRows([]);
    }

    // 费用类型
    Sheet3.columns = sheet3.columns;
    Sheet3.addRows(sheet3.arr);

    // 设置 下拉框 值
    new Array(50000).fill(0).forEach((_, idx) => {
      const row = idx + 2;

      if (!quotationType) {
        // 费用类型
        Sheet1.getCell(row, 1).dataValidation = {
          type: 'list',
          formulae: [`=Sheet3!$A$2:$A${sheet3.arr.length + 1}`]
        };

        return;
      }

      // 分区名称，如果存在则设置
      if (list && list.length > 0) {
        Sheet1.getCell(row, 1).dataValidation = {
          type: 'list',
          formulae: [`=Sheet2!$A$2:$A${sheet2.arr.length + 1}`]
        };
      }

      // 费用类型
      Sheet1.getCell(row, 2).dataValidation = {
        type: 'list',
        formulae: [`=Sheet3!$A$2:$A${sheet3.arr.length + 1}`]
      };
    });

    return wb;
  };

  /**
   * 下载模板
   * @param {any[]} list 所有分区/车线
   * @param {any[]} feeList 费用类型
   * @param businessType 业务类型
   * @param quotationType 报价类型
   */
  const downloadTemplate = async(list, feeList, businessType, quotationType) => {
    const wb = createTemplate(list, feeList, businessType, quotationType);

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/octet-stream'
    });

    const saveName = `${i18n.t('basicData.ImportOtherQuoteTemplatesBulk')}.xlsx`;

    saveAs(blob, saveName);
  };

  /**
   * 导入模板处理
   * @param list 分区/车线
   * @param data 模板数据
   * @returns {any[]}
   */
  const importTemplate = (list, data) => {
    const subregionID = list.map(item => item.id);
    console.log(subregionID, 'ID');
    const headArr = getHeadObj(list);
    console.log(headArr, 'headArr');
    const fileList = data[0].results;
    console.log(fileList, 'fileList');
    const arr = [];
    fileList.forEach(item => {
      const obj = {
        ...ROW_TMP
      };

      Object.entries(item).forEach(([key, value]) => {
        console.log(key, value);
        for (let i = 0; i < headArr.length; i++) {
          const item = headArr[i];
          if (!item || !item.header) continue;
          if (key === item.header) {
            // 需要解析字段
            if ([0, 1].includes(i)) {
              const parts = typeof value === 'string' ? value.split(SEPARATOR) : [];
              if (parts.length > 1) {
                obj[item.key] = parts[1];
              }
            } else {
              obj[item.key] = value >= 0 ? value : 0.01;
            }
          }
        }
        return obj;
      });
      arr.push(obj);
    });
    return arr;
  };

  /**
   * 下载报价
   * @param list 分区/车线
   * @param businessType 业务类型
   * @param feeList 费用类型
   * @param quotationType 报价类型
   * @param data 报价数据
   * @returns {Promise<void>}
   */
  const downloadQuotation = async(list, feeList, businessType, quotationType, data) => {
    const wb = createTemplate(list, feeList, businessType, quotationType, data);

    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/octet-stream'
    });

    const saveName = `${i18n.t('basicData.otherRules')}.xlsx`;

    saveAs(blob, saveName);
  };

  return {
    SEPARATOR,
    downloadTemplate,
    importTemplate,
    downloadQuotation
  };
})();
